// extracted by mini-css-extract-plugin
module.exports = {"handContainer":"hand_handContainer__YOE4m","cardContainer":"hand_cardContainer__1pqGR","title":"hand_title__1cOkt"};